export const handleExternalLink = (link: string | undefined) => {
    if (!link) return;

    const url = link.startsWith("http") ? link : `https://${link}`;
    window.open(url, "_blank");
};

export const createCallToActionProps = (label: string | undefined, link: string | undefined) => {
    if (!label) return undefined;

    return {
        label,
        onClick: () => handleExternalLink(link),
    };
};
